import { render, staticRenderFns } from "./NaikinimasArchyvarasParametrai.vue?vue&type=template&id=5df319bc&scoped=true&"
import script from "./NaikinimasArchyvarasParametrai.vue?vue&type=script&lang=js&"
export * from "./NaikinimasArchyvarasParametrai.vue?vue&type=script&lang=js&"
import style0 from "./NaikinimasArchyvarasParametrai.vue?vue&type=style&index=0&id=5df319bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df319bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
